



<div class="offers-menu-container">
  <mat-tab-group class="_headers-hidden _k-menu-tabs" [selectedIndex]="tabIndex" [dynamicHeight]="false" (selectedTabChange)="onSelectedTabChange($event)">
    <mat-tab class="dashboard-panel-container">
      <div id="main-tab-scroll-content" class="tab-scroll-content _scrollable" scrollSpy [spiedTags]="['DIV']" [spyOffset]="62" (sectionChange)="onSectionChange($event)">

        @if (!$storage.menuDisabled) {

          @if ($storage.parsedBanners?.hero) {
            <app-banner-carousel [slides]="$storage.parsedBanners.hero" (onBannerClick)="onBannerClick($event)"></app-banner-carousel>
          }

          @if ($storage.canCreateTabOrder || $storage.hasLoyaltyOpt || $storage.menuMessages) {
            <div class="p-3 menu-messages-container">
              <!--START TAB ORDER PANEL-->
              @if ($storage.canCreateTabOrder) {

                <div class="alert-accent animated fast zoomIn" (mousedown)="dialogsService.showTabOrderOptions({actions:[], table:$storage.tableNumber})">
                  <div class="alert-accent-header">
                    <div class="_title">{{ 'OAT.menu_prompt_title' | translate }}</div>
                    <mat-icon svgIcon="arrow_next" class="rotate-rtl"></mat-icon>
                  </div>
                  <div class="alert-accent-body">{{ 'OAT.menu_prompt_desc' | translate }}</div>
                </div>

              }
              <!--END TAB ORDER PANEL-->
              <!--START MENU MESSAGES-->
              @if ($storage.menuMessages) {
                <div class="alert-accent alert-accent-alt2 animated fast zoomIn" style="display: flex; flex-direction: column; gap: 15px">
					<div class="alert-accent-body" style="display: flex; flex-direction: column; gap: 10px">
						@for (message of $storage.menuMessages; track message) {
							<div class=" pre-wrap">{{ message.trans }}</div>
						}
					</div>
                </div>
              }
              <!--END MENU MESSAGES-->
              <!--START LOYALTY OPT-->
              @if ($storage.hasLoyaltyOpt) {
                <div class="alert-accent animated fast zoomIn" (mousedown)="onLoyalty()">
                  @if ($storage.loyalty?.loyaltyData) {
                    <div class="alert-accent-header">
                      <mat-icon svgIcon="loyalty_logo" class="me-3 lg" style="line-height: 20px;"></mat-icon>
                      <div class="_title">
                        <div>{{ '_LOYALTY.greeting' | translate: {name: $storage.loyalty?.customer?.fullName} }}.</div>
                        <div class="_balance-row">
                          @if ($storage.loyalty?.loyaltyData?.balance.visibility.pointsVisible) {
                            <div>
                              <span>{{$storage.loyalty?.loyaltyData?.pointsNickName || ('_LOYALTY.points_balance' | translate)}}</span>
                              <strong [class.text-lt]="$storage.loyalty?.loyaltyData?.balance.visibility?.pointsDisabled">{{$storage.loyalty?.loyaltyData?.balance.cashBackPoints | number:'0.0-0'}}</strong>
                            </div>
                          }
                          @if ($storage.loyalty?.loyaltyData?.balance.visibility.compsVisible) {
                            <div>
                              <span>{{'_LOYALTY.compensation' | translate}}</span>
                              <strong>{{$storage.loyalty?.loyaltyData?.balance.moneyCompensation | lcurrency}}</strong>
                            </div>
                          }
                          @if ($storage.loyalty?.loyaltyData?.balance.visibility.prepaidVisible) {
                            <div>
                              <span>{{'_LOYALTY.card_balance' | translate}}</span>
                              <strong>{{$storage.loyalty?.loyaltyData?.balance.prePaid | lcurrency}}</strong>
                            </div>
                          }
                          @if ($storage.loyalty?.loyaltyData?.balance.visibility.pointsStoreVisible) {
                            <div>
                              <span>{{$storage.loyalty?.loyaltyData?.pointsNickName || ('_LOYALTY.store_points' | translate)}}</span>
                              <strong [class.text-lt]="$storage.loyalty?.loyaltyData?.balance.visibility?.pointsDisabled">{{($storage.loyaltyOffersMap ? $storage.loyaltyOffersMap.remainingPoints : $storage.loyalty?.loyaltyData?.balance.pointsStorePoints) | number:'0.0-0'}}</strong>
                            </div>
                          }
                        </div>

                      </div>
                      <mat-icon svgIcon="arrow_next" class="rotate-rtl"></mat-icon>
                    </div>
                  } @else {
                    <div class="alert-accent-header">
                      <div class="_title">{{ '_LOYALTY.loginSubCaption' | translate }}.</div>
                      <mat-icon svgIcon="loyalty_logo"></mat-icon>
                    </div>
                  }
                </div>
              }
              <!--END LOYALTY OPT-->
            </div>
          }
        }

        <div id="menu_nav_container" class="categories-header" [class.with-subcat]="activeSubCat != null">
          @if ($storage.catalog.userOffers && $storage.catalog.userOffers.length) {
            <div class="categories-header-member with-icon" style="padding:9px 15px;"
              id="nav_userOffers"
              [class.active]="currentSection == 'userOffers'"
              (mousedown)="menuCatClick({_id: 'userOffers'}, 0)">
              <!--<div class="_inner">{{'TD.historic_orders' | translate}}</div>-->
              <mat-icon [svgIcon]="currentSection == 'userOffers' ? 'history_alt' : 'history'" color="accent"></mat-icon>
            </div>
          }

          @for ( menu of $storage.catalog.view; track menu._id; let index = $index; ) {
            <div class="categories-header-member" tabindex="0"
              [id]="'nav_' + menu._id"
              [class.active]="currentSection == menu._id"
              (mousedown)="menuCatClick(menu, index)">
              <div class="_inner">{{ menu.name }}</div>
            </div>
          }
        </div>

        <div style="padding: 0 1rem">
          @if ($storage.config?.eatin?.preparationTime) {
            <div class="alert mb-0" style="background-color: #eeeeee;">
              <div class="alert-heading text-center" style="color: #0b2e13" [innerHTML]="'TD.prep_time' | translate: {v:$storage.config?.eatin?.preparationTime}"></div>
            </div>
          }
          @if ($storage.order.promotion?.showMessageInMenu) {
            <div class="alert alert-success mb-0 mt-3">
              <div class="alert-heading" style="display: flex; align-items:center; justify-content:center; gap:5px;">
                <mat-icon class="" svgIcon="badge_percent"></mat-icon>
                {{$storage.order.promotion.message}}
              </div>
            </div>
          }
        </div>

        <div id="userOffers" >
          @if ($storage.catalog.userOffers && $storage.catalog.userOffers.length) {
            <div class="offers-menu-cat" style="border-bottom-width: 1px;">
              <div class="offers-menu-cat-header">
                <div class="_cat-header-title"><div>{{'TD.historic_orders' | translate}}</div></div>
              </div>
              <menu-offers-container class="simple_card flat">
                @for (offer of $storage.catalog.userOffers; track offer) {
                  <ng-container *ngTemplateOutlet="menuItem; context: { offer: offer.preSelection, isBasketOffer: true }"></ng-container>
                }
              </menu-offers-container>
            </div>
          }
        </div>

        @for ( menu of $storage.catalog.view; track menu._id; let last = $last ) {
          @if ($storage.parsedBanners[menu._id]) {
            <app-banner-carousel [slides]="$storage.parsedBanners[menu._id]" (onBannerClick)="onBannerClick($event)"></app-banner-carousel>
          }
          <div [id]="menu._id" class="offers-menu-cat" [class.last]="last">
            <div class="offers-menu-cat-header">
              <div class="_cat-header-title"><div>{{menu.name}}</div></div>
              <div class="_cat-header-description">{{menu.message}}</div>
            </div>
            <ng-container *ngTemplateOutlet="categoryItems; context: {menu:menu, enableBack:false}"></ng-container>
          </div>
        }
      </div>
    </mat-tab>
    @for (menu of $storage.catalog.folders; track menu) {
      <mat-tab class="dashboard-panel-container">
        <ng-container *ngTemplateOutlet="subFolder; context: {menu:menu}"></ng-container>
      </mat-tab>
    }
  </mat-tab-group>
</div>

<ng-template #subFolder let-menu="menu">
  <div class="offers-menu-cat last">
    <div class="offers-menu-cat-header _sticky"  (mousedown)="menuBackClick(activeSubCat)">
      <div class="_cat-header-title">
        <!--<mat-icon class="rotate-ltr">keyboard_arrow_right</mat-icon>-->
        <div>{{menu.name}}</div>
      </div>
      <div class="_cat-header-description">{{menu.message}}</div>
    </div>
    <ng-container *ngTemplateOutlet="categoryItems; context: {menu:menu}"></ng-container>
  </div>
</ng-template>

<ng-template #categoryItems let-menu="menu">
  <menu-offers-container class="{{menu.member_display}}">
    @for (cat of menu.items; track cat) {
      <ng-container *ngTemplateOutlet="menuItem; context: { offer: cat }"></ng-container>
    }
  </menu-offers-container>
</ng-template>

<ng-template #menuItem let-offer="offer" let-isBasketOffer="isBasketOffer">
  @if (offer.type == 'folder') {
    <div class="menu-folder"
      [id]="'cat_' + offer._id"
      (mousedown)="menuSubfolderClick(offer,$event)">
      <div class="menu-folder-body">
        <div class="_image" [ngStyle]="offer.catStyle || offer.cardStyle" [class.stock-disabled]="offer.stockDisabled">
          <img [appImageSrc]="offer.imageURL" [model]="offer" loading="lazy"/>
        </div>
        <div class="menu-folder-title">{{offer.name}}</div>
        <mat-icon class="rotate-rtl">keyboard_arrow_right</mat-icon>
      </div>
    </div>
  } @else {
    <div class="menu-offer"
      [id]="'cat_' + offer._id"
      (mousedown)="menuItemClick(offer,$event)"
      [ngClass]="{'_active':$storage.order.offerCounters[offer.offer], '_folder':offer.type == 'folder', '_disabled': offer.stockDisabled}">
      <div class="menu-offer-body">
        <div class="_body">
          <div class="menu-offer-title">{{offer.name}}</div>
          @if (isBasketOffer) {

            <div class="menu-offer-summary">{{offer._item?.summary?.text}}</div>
            <div class="menu-offer-price">
              @if (offer.total > 0) {
                <div class="_price">{{offer.total | lcurrency}}</div>
              }
            </div>
          } @else  {
            @if (offer.description_display != 'hide') {
              <div class="menu-offer-description">{{ offer.description }}</div>
            }
            <div class="menu-offer-price">
              @if (offer.price > 0) {
                <div class="_price">{{offer.price | lcurrency}}</div>
              } @else {
                <div class="_price"></div>
              }
              <app-offer-attributes [offer]="offer"></app-offer-attributes>
            </div>
          }
          @if(offerDiners[offer.offer]) {
            <app-inline-diners [diners]="offerDiners[offer.offer].diners" class="with-label"></app-inline-diners>
          }
        </div>

        <!--[class.no-image]="offer.iconImage" [appBgImage]="offer.imageURL" [model]="cat"-->
        <div class="_image" [ngStyle]="offer.catStyle || offer.cardStyle" [class.stock-disabled]="offer.stockDisabled">
          <img [appImageSrc]="offer.imageURL" [model]="offer" loading="lazy"/>
          <app-offer-marketing [offer]="offer" [$storage]="$storage"></app-offer-marketing>
        </div>
      </div>
    </div>
  }
</ng-template>
